export const RUB = 'RUB'
export const EUR = 'EUR'
export const currencies = [RUB, EUR]
